import { canv } from "@/canv/global";
import { Shape } from "../shape";

export class ShapeVerticalPool extends Shape {
    width = 200;
    height = 180;
    includeText = false;

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 50;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.beginPath();

        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);

        canv.ctx.moveTo(x + w * 0.33, y);
        canv.ctx.lineTo(x + w * 0.33, y + h);

        canv.ctx.moveTo(x + w * 0.66, y);
        canv.ctx.lineTo(x + w * 0.66, y + h);

        canv.ctx.moveTo(x, y + h * 0.22);
        canv.ctx.lineTo(x + w, y + h * 0.22);

        canv.ctx.moveTo(x, y + h * 0.44);
        canv.ctx.lineTo(x + w, y + h * 0.44);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="${stroke}" fill="${fill}" stroke-linejoin="round" d="M22 7.17H2M8.66 3.5H2v17h6.66m0-17H22v17H8.66m0-17v17m6.64-17v17m6.7-9.53H2"/>
            </svg>
        `;
    }
}
